// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"448061fe","57":"95c906c8","219":"296b4a7c","455":"399606b7","555":"5f0e69df","797":"16a6b632","852":"efabf713","910":"45fa6418","936":"57975295","977":"8c72bf08"}[chunkId] + ".chunk.js";
};